import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getNameInitialsFromFullName } from '../../core/util/string';
import styled, { css } from 'styled-components';
import { fontFamily, fontSize } from '../../constants/text';
import { colors } from '../../constants/colors';

const Container = styled.div`
  border: 1px solid ${colors.grayvy};
  font-family: ${fontFamily.book};
  cursor: pointer;
  padding-left: 20px;
  border-radius: 4px;
`;

const NameContainer = styled.div`
  background-color: ${colors.blueJayWay};
  ${props => css`
    background-color: ${props.color.primary};
  `};
  border-radius: 50%;
  color: white;
  height: 30px;
  margin-right: 15px;
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
  width: 30px;
  line-height: 30px;
  display: inline-block;
  font-size: ${fontSize.default};
`;

class SelectValue extends PureComponent {
  render() {
    const { className } = this.props;
    const fullName = this.props.value.label;

    return (
      <Container className={className} title={fullName}>
        <div>
          <NameContainer color={this.props.value.color}>
            {getNameInitialsFromFullName(fullName, '')}
          </NameContainer>
          {fullName}
        </div>
      </Container>
    );
  }
}

SelectValue.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.object,
  customArrow: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.string]),
};
export default SelectValue;
